export default function Footer() {
  return (
    <footer
      className="pointer-events-none absolute bottom-1 left-0 z-40 w-full bg-transparent px-3 text-center"
      dir="rtl"
    >
      <p className="m-0 text-[10px] font-normal leading-tight text-[#3F4044]/80 sm:text-xs">
        تمت البرمجة و كتابة المعادلات من قبل ( Murtadha abdulzahra)
      </p>
    </footer>
  );
}
